import TR from 'utils/TR';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import T from 'utils/T';
import ex from 'utils/ex';
import * as Luxon from 'luxon'
import useFloating from 'hooks/layers/useFloating';
import FocusableButton from 'components/common/FocusableButton';
import useBldsugrExistDate from 'hooks/communication/useBldsugrExistDate';

const PERIOD_CALENDAR_ID = 'PeriodCalendar';
export default function PeriodCalendarButton(props) {
  const {
    patient_no,
    category,
    luxon_start,
    luxon_end,
    setPeriodStart,
    setPeriodEnd,
    ...rest
  } = props || {};
  const [list, setList] = Recoil.useRecoilState(AppStore.floatings.list('App'));
  const [hash, setHash] = Recoil.useRecoilState(AppStore.floatings.hash('App'));
  const {
    open,
    update,
    close,
  } = useFloating({ setList, setHash });

  const ref = React.useRef();
  const onOuterClick = React.useCallback((ref) => (e) => {
    if (!ref?.current?.contains(e.target)) {
      close(PERIOD_CALENDAR_ID);
    }
  }, [close]);
  const onClose = React.useCallback((e) => {
    close(PERIOD_CALENDAR_ID);
  }, [close]);
  const onSubmit = React.useCallback((start, end) => (e) => {
    setPeriodStart(() => start.toFormat('yyyyMMdd'));
    setPeriodEnd(() => end.toFormat('yyyyMMdd'));
    close(PERIOD_CALENDAR_ID);
  }, [close, setPeriodEnd, setPeriodStart]);


  const {
    requestBldsugrExistDate,
  } = useBldsugrExistDate();
  const [glocose_exists, setGlocoseExists] = Recoil.useRecoilState(AppStore.assets.glocose_exists);
  React.useEffect(()=>{
    setGlocoseExists(() => ({}));
  },[patient_no, setGlocoseExists]);
  const onPeriodChanged = React.useCallback((start, end) => {
    requestBldsugrExistDate({
      search_start_time: start,
      search_end_time: end,
      patient_no,
    }, (success, data) => {
      if (success) {
        setGlocoseExists((exists) => ({ ...exists, ...(data.bldsugr_date_list.reduce((a, c) => ({ ...a, [c]: true }), {})) }));
      }
    });
  }, [patient_no, requestBldsugrExistDate, setGlocoseExists]);

  React.useEffect(() => {
    update({
      id: PERIOD_CALENDAR_ID,
      reference: ref,
      placement: 'bottom-right',
      connection: 'none',
      width: 'auto',
      height: 'auto',
      veilable: true,
      stickable: true,
      movable: false,
      closable: false,
      escapable: true,
      modal: false,
      type: PERIOD_CALENDAR_ID,
      events: {
        onOuterClick,
        onClose,
        onSubmit,
        onPeriodChanged,
      },
      props: {
        luxon_start,
        luxon_end,
        date_availables: glocose_exists,
      },
    });
  }, [glocose_exists, luxon_end, luxon_start, onClose, onOuterClick, onPeriodChanged, onSubmit, update]);

  const onClick = React.useCallback(() => {
    open({
      id: PERIOD_CALENDAR_ID,
      reference: ref,
      placement: 'bottom-right',
      connection: 'none',
      width: 'auto',
      height: 'auto',
      veilable: true,
      stickable: true,
      movable: false,
      closable: false,
      escapable: true,
      modal: false,
      type: PERIOD_CALENDAR_ID,
      events: {
        onOuterClick,
        onClose,
        onSubmit,
        onPeriodChanged,
      },
      props: {
        luxon_start,
        luxon_end,
        date_availables: {},
      },
    });
  }, [open, onOuterClick, onClose, onSubmit, onPeriodChanged, luxon_start, luxon_end]);

  return (
    <FocusableButton
      {...ex(['PeriodButton', 'PeriodCalendarButton'], rest)}
      {...{
        ref,
        onClick,
      }}
    >
      {T('직접선택')}
    </FocusableButton>
  );
}
